import { useLang } from "@/context/LanguageContext";
import Reveal from "./Reveal";
import { scrollToSection as scrollTo } from "@/lib/scroll";
import { Truck, ShieldCheck, Home, Building2, ArrowRight } from "lucide-react";

export default function Services() {
  const { t } = useLang();
  const items = [
    { icon: Truck, t: t("services.s1_t"), d: t("services.s1_d") },
    { icon: ShieldCheck, t: t("services.s2_t"), d: t("services.s2_d") },
    { icon: Home, t: t("services.s3_t"), d: t("services.s3_d") },
    { icon: Building2, t: t("services.s4_t"), d: t("services.s4_d") },
  ];
  return (
    <section id="services" className="py-20 md:py-28 bg-ksy-bg" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <Reveal className="max-w-2xl">
          <span className="text-sm font-bold uppercase tracking-[0.18em] text-ksy-blue">{t("services.label")}</span>
          <h2 className="mt-3 font-display font-extrabold text-3xl md:text-4xl text-ksy-navy tracking-tight">{t("services.title")}</h2>
          <p className="mt-3 text-lg text-slate-500">{t("services.subtitle")}</p>
        </Reveal>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {items.map((it, i) => (
            <Reveal key={i} delay={i * 0.07} testid={`service-card-${i}`}>
              <button
                onClick={() => scrollTo("book")}
                className="group h-full w-full text-left rounded-2xl bg-white border border-slate-200 p-7 hover:shadow-xl hover:border-blue-200 hover:-translate-y-1 transition-all duration-300"
              >
                <span className="grid place-items-center w-12 h-12 rounded-xl bg-blue-50 text-ksy-blue mb-6 group-hover:bg-ksy-blue group-hover:text-white transition-colors">
                  <it.icon className="w-6 h-6" />
                </span>
                <h3 className="font-display font-bold text-lg text-ksy-navy">{it.t}</h3>
                <p className="mt-2 text-sm text-slate-500 leading-relaxed">{it.d}</p>
                <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-bold text-ksy-blue">
                  {t("hero.cta")} <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </span>
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
